<template>
  <div>
    <template v-if="config.search_fields">
      <p
        style="
          font-size: 15px;
          margin-top: 10px;
          line-height: 25px;
          color: #004279;
          font-weight: 500;
        "
      >
        - 검색 기간이 길 경우 데이터 로딩이 오래 걸릴 수 있습니다.<br />
        - 검색 기간은
        <span style="font-weight: bold; color: red">최대 6개월</span
        >입니다.<br />
        - Language Training을
        <span style="font-weight: bold; color: red">1회 이상 학습</span>해야
        조회 가능합니다.<br />
        - 종료일이 지난 학생의 경우 조회 되지 않습니다.
        <span style="font-weight: bold; color: red"
          >단, 아이디 만료 전일 경우 학생 개별 조회는 가능합니다.</span
        >
      </p>
      <form @submit.prevent="search(true, 'ALL')">
        <div class="col-lg-12 offset-lg-0 search_box">
          <table class="table_search">
            <colgroup>
              <col style="width: 10%" />
              <col style="width: 12%" />
              <col style="width: 10%" />
              <col style="width: 12%" />
              <col style="width: 10%" />
              <col style="width: 20%" />
              <col style="width: 10%" />
              <col style="width: 14%" />
            </colgroup>
            <template v-if="this.$root.guiPerm == 'ROOT'">
              <tr>
                <th
                  style="
                    width: 140px;
                    font-weight: 100;
                    border-top: 1px solid #ccc;
                  "
                >
                  본부분류
                </th>
                <td
                  style="text-align: left; border-top: 1px solid #ccc"
                  colspan="7"
                >
                  <button
                    type="button"
                    class="btn btn-warning btn-sm"
                    style="width: 160px; margin: 2px; padding: 10px 0"
                    v-for="firstlist in firstlists"
                    v-bind:key="firstlist.id"
                    @click="
                      firstselected = firstlist.id;
                      viewSecond();
                    "
                  >
                    {{ firstlist.name }}
                  </button>
                </td>
              </tr>
            </template>
            <template
              v-if="
                this.$root.guiPerm == 'ROOT' || this.$root.guiPerm == 'LOCAL'
              "
            >
              <tr>
                <th
                  style="
                    width: 140px;
                    font-weight: 100;
                    border-top: 1px solid #ccc;
                  "
                >
                  캠퍼스분류
                </th>
                <td
                  style="text-align: left; border-top: 1px solid #ccc"
                  colspan="7"
                >
                  <select
                    v-model="subselected"
                    @change="viewclass()"
                    style="border: 1px solid #ccc; padding: 4px"
                  >
                    <option value>캠퍼스</option>
                    <option
                      v-for="sublist in sublists"
                      :value="sublist.id"
                      v-bind:key="sublist.id"
                    >
                      {{ sublist.name }}
                    </option>
                  </select>
                </td>
              </tr>
            </template>
            <tr>
              <th>클래스명</th>
              <td>
                <div class="input-group mb-12">
                  <div class="input-group-prepend">
                    <select
                      v-model="cate_filter_class"
                      @change="
                        viewClassStudent();
                        selectedSearchClass(this);
                      "
                      class="custom-select flex_center"
                    >
                      <option value>클래스</option>
                      <option
                        v-for="classlist in subclasslists"
                        :value="classlist.id"
                        v-bind:key="classlist.id"
                      >
                        {{ classlist.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </td>
              <th>학생이름</th>
              <td>
                <div class="input-group mb-12">
                  <div class="input-group-prepend">
                    <select
                      v-model="cate_filter_student"
                      @change="selectedSearchstudent(this)"
                      class="custom-select flex_center"
                    >
                      <option value>전체</option>
                      <option
                        v-for="studentlist in substudentlists"
                        :value="studentlist.id"
                        v-bind:key="studentlist.id"
                      >
                        {{ studentlist.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </td>
              <th>기간</th>
              <td>
                <div class="input-group mb-12">
                  <div class="input-group-prepend">
                    <input
                      type="date"
                      v-model="search_start"
                      id="search_start"
                      style="
                        border: 1px solid #ccc;
                        border-radius: 4px;
                        height: 38px;
                        padding: 3px;
                      "
                    />
                    &nbsp;~&nbsp;
                    <input
                      type="date"
                      v-model="search_end"
                      id="search_end"
                      style="
                        border: 1px solid #ccc;
                        border-radius: 4px;
                        height: 38px;
                        padding: 3px;
                      "
                    />
                  </div>
                </div>
              </td>
              <th>종류</th>
              <td colspan="3">
                <div
                  class="btn-group"
                  role="group"
                  aria-label="Basic radio toggle button group"
                >
                  <input
                    type="radio"
                    class="btn-check"
                    name="btnradio"
                    id="btnradio1"
                    autocomplete="off"
                    v-model="searchType"
                    value="Count"
                  />
                  <label
                    class="btn btn-outline-danger"
                    for="btnradio1"
                    style="font-size: 13px"
                    >학습횟수</label
                  >

                  <input
                    type="radio"
                    class="btn-check"
                    name="btnradio"
                    id="btnradio2"
                    autocomplete="off"
                    v-model="searchType"
                    value="Ponit"
                  />
                  <label
                    class="btn btn-outline-danger"
                    for="btnradio2"
                    style="font-size: 13px"
                    >확습점수</label
                  >
                </div>
              </td>
            </tr>
          </table>
        </div>

        <div class="main-card mb-3 card">
          <div class="card-header">
            <i class="header-icon lnr-license icon-gradient bg-plum-plate"> </i>
            <div class="btn-actions-pane-right">
              <div role="group" class="btn-group-sm nav btn-group">
                <a
                  data-toggle="tab"
                  @click="search(true, 'ALL')"
                  class="btn-shadow btn btn-primary show active"
                  style="padding: 10px 2px"
                  >ALL</a
                >
                <a
                  data-toggle="tab"
                  @click="searchAme(true, 'American')"
                  class="btn-shadow btn btn-info show active"
                  style="padding: 10px 2px"
                  >American</a
                >
                <a
                  data-toggle="tab"
                  @click="searchLA(true, 'WS Listen', 221)"
                  class="btn-shadow btn btn-success show"
                  style="padding: 10px 2px"
                  >WS Listen</a
                >
                <a
                  data-toggle="tab"
                  @click="searchLA(true, 'WS Shadowing', 222)"
                  class="btn-shadow btn btn-success show"
                  style="padding: 10px 2px"
                  >WS Shadowing</a
                >
                <a
                  data-toggle="tab"
                  @click="searchLA(true, 'WS Pretest', 223)"
                  class="btn-shadow btn btn-success show"
                  style="padding: 10px 2px"
                  >WS Pretest</a
                >
                <a
                  data-toggle="tab"
                  @click="searchLA(true, 'WS Test', 224)"
                  class="btn-shadow btn btn-success show"
                  style="padding: 10px 2px"
                  >WS Test</a
                >
                <a
                  data-toggle="tab"
                  @click="searchLA(true, 'WW Practice', 231)"
                  class="btn-shadow btn btn-success show"
                  style="padding: 10px 2px"
                  >WW Practice</a
                >
                <a
                  data-toggle="tab"
                  @click="searchLA(true, 'WW Quiz', 232)"
                  class="btn-shadow btn btn-success show"
                  style="padding: 10px 2px"
                  >WW Quiz</a
                >
                <a
                  data-toggle="tab"
                  @click="searchLA(true, 'WW Pretest', 233)"
                  class="btn-shadow btn btn-success show"
                  style="padding: 10px 2px"
                  >WW Pretest</a
                >
                <a
                  data-toggle="tab"
                  @click="searchLA(true, 'WW Test', 234)"
                  class="btn-shadow btn btn-success show"
                  style="padding: 10px 2px"
                  >WW Test</a
                >
                <a
                  data-toggle="tab"
                  @click="searchLA(true, 'SS Shadowing', 241)"
                  class="btn-shadow btn btn-warning show"
                  style="padding: 10px 2px"
                  >SS Shadowing</a
                >
                <a
                  data-toggle="tab"
                  @click="searchLA(true, 'SS Practice', 242)"
                  class="btn-shadow btn btn-warning show"
                  style="padding: 10px 2px"
                  >SS Practice</a
                >
                <a
                  data-toggle="tab"
                  @click="searchLA(true, 'SS Presentation', 243)"
                  class="btn-shadow btn btn-warning show"
                  style="padding: 10px 2px"
                  >SS Presentation</a
                >
                <a
                  data-toggle="tab"
                  @click="searchLA(true, 'SS Test', 244)"
                  class="btn-shadow btn btn-warning show"
                  style="padding: 10px 2px"
                  >SS Test</a
                >
                <a
                  data-toggle="tab"
                  @click="searchLA(true, 'SW Practice', 251)"
                  class="btn-shadow btn btn-warning show"
                  style="padding: 10px 2px"
                  >SW Practice</a
                >
                <a
                  data-toggle="tab"
                  @click="searchLA(true, 'SW Quiz', 252)"
                  class="btn-shadow btn btn-warning show"
                  style="padding: 10px 2px"
                  >SW Quiz</a
                >
                <a
                  data-toggle="tab"
                  @click="searchLA(true, 'SW Test', 253)"
                  class="btn-shadow btn btn-warning show"
                  style="padding: 10px 2px"
                  >SW Test</a
                >
                <a
                  data-toggle="tab"
                  @click="searchLA(true, 'D Practice', 261)"
                  class="btn-shadow btn btn-danger show"
                  style="padding: 10px 2px"
                  >D Practice</a
                >
                <a
                  data-toggle="tab"
                  @click="searchLA(true, 'D Live', 262)"
                  class="btn-shadow btn btn-danger show"
                  style="padding: 10px 2px"
                  >D Live</a
                >
              </div>
            </div>
          </div>
        </div>
      </form>
    </template>
    <div class="col-lg-6 offset-lg-3">
      <div class="flex_center">
        <button
          class="btn btn-secondary"
          @click="search(true, 'ALL')"
          v-if="!config.no_search"
        >
          조회
        </button>
        <button
          class="btn btn-success"
          @click="getExcel()"
          v-if="strName == 'ALL'"
        >
          <i class="fas fa-file-excel" style="margin-right: 5px"></i>엑셀저장
        </button>
        <slot name="actions" :records="records" />
      </div>
    </div>
    <div style="margin: 10px">
      총 건수 : <span style="font-weight: bold">{{ total }}</span
      >건
    </div>
    <slot name="resultactions" :records="records" :checked="checked" />

    <div style="text-align: left">
      &nbsp;&nbsp;Report type :
      <span class="btn btn-primary btn-sm">{{ strFullName }}</span>
    </div>

    <table class="table table-hover table-striped">
      <thead>
        <template v-if="strName == 'ALL'">
          <tr>
            <th rowspan="2">No</th>
            <th rowspan="2">Class</th>
            <th rowspan="2">Id</th>
            <th rowspan="2">Name</th>
            <th colspan="4" style="background: #f0f0f0 !important">
              Word Speaking
            </th>
            <th colspan="4">Word Writing</th>
            <th colspan="4" style="background: #f0f0f0 !important">
              Sentence Speaking
            </th>
            <th colspan="3">Sentence Writing</th>
            <th colspan="2" style="background: #f0f0f0 !important">Dubbing</th>
            <th rowspan="2">Total</th>
          </tr>
          <tr>
            <td style="background: #f0f0f0 !important">Listen</td>
            <td style="background: #f8f8f8 !important">Shadowing</td>
            <td style="background: #f0f0f0 !important">Pretest</td>
            <td style="background: #f8f8f8 !important">Test</td>
            <td style="background: #f0f0f0 !important">Practice</td>
            <td style="background: #f8f8f8 !important">Quiz</td>
            <td style="background: #f0f0f0 !important">Pretest</td>
            <td style="background: #f8f8f8 !important">Test</td>
            <td style="background: #f0f0f0 !important">Shadowing</td>
            <td style="background: #f8f8f8 !important">Practice</td>
            <td style="background: #f0f0f0 !important">Presentation</td>
            <td style="background: #f8f8f8 !important">Test</td>
            <td style="background: #f8f8f8 !important">Practice</td>
            <td style="background: #f0f0f0 !important">Quiz</td>
            <td style="background: #f8f8f8 !important">Test</td>
            <td style="background: #f0f0f0 !important">Practice</td>
            <td style="background: #f8f8f8 !important">Live</td>
          </tr>
        </template>
        <template v-else-if="strName == 'American'">
          <tr>
            <th scope="col">No</th>
            <th scope="col">Class</th>
            <th scope="col">ID</th>
            <th scope="col">Name</th>
            <th scope="col">Type</th>

            <th scope="col">Course</th>
            <th scope="col">Grade</th>
            <th scope="col">Step</th>
            <th scope="col">Subject</th>
            <th scope="col">Time</th>
            <th scope="col">Activity</th>
            <th scope="col">Point</th>
            <th scope="col">Date</th>
            <th scope="col">Detail</th>
          </tr>
        </template>
        <template v-else>
          <tr>
            <th scope="col">No</th>
            <th scope="col">Class</th>
            <th scope="col">ID</th>
            <th scope="col">Name</th>
            <th scope="col">Type</th>
            <th scope="col">Activity</th>
            <th scope="col">Title</th>
            <th scope="col">Section</th>
            <th scope="col">Point</th>
            <th scope="col">Date</th>
            <th scope="col">Detail</th>
          </tr>
        </template>
      </thead>
      <tbody>
        <slot name="items" :records="records" :strFullName="strFullName"></slot>
      </tbody>
    </table>
    <div style="display: flex; align-items: center; justify-content: center">
      <template v-if="strName == 'ALL'">
        <v-pagination
          v-model="page"
          :pages="Math.ceil(total / limit)"
          :range-size="3"
          active-color="#DCEDFF"
          @update:modelValue="
            (i) => {
              offset = (i - 1) * limit;
              search(false, 'ALL');
            }
          "
        /><select
          v-model="limit"
          @change="
            (i) => {
              offset = 0;
              page = 1;
              search(false, 'ALL');
            }
          "
          style="
            padding: 4px;
            font-size: 12px;
            border: 1px solid #ccc;
            margin-left: 10px;
          "
        >
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
          <option value="500" disabled>500</option>
          <option value="1000" disabled>1000</option>
        </select>
      </template>
      <template v-else-if="strName == 'American'">
        <v-pagination
          v-model="page"
          :pages="Math.ceil(total / limit)"
          :range-size="3"
          active-color="#DCEDFF"
          @update:modelValue="
            (i) => {
              offset = (i - 1) * limit;
              searchAme(false, 'American');
            }
          "
        /><select
          v-model="limit"
          @change="
            (i) => {
              offset = 0;
              page = 1;
              searchAme(false, 'American');
            }
          "
          style="
            padding: 4px;
            font-size: 12px;
            border: 1px solid #ccc;
            margin-left: 10px;
          "
        >
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
          <option value="500" disabled>500</option>
          <option value="1000" disabled>1000</option>
        </select>
      </template>
      <template v-else>
        <v-pagination
          v-model="page"
          :pages="Math.ceil(total / limit)"
          :range-size="3"
          active-color="#DCEDFF"
          @update:modelValue="
            (i) => {
              offset = (i - 1) * limit;
              searchLA(false, strName, sint);
            }
          "
        /><select
          v-model="limit"
          @change="
            (i) => {
              offset = 0;
              page = 1;
              searchLA(false, strName, sint);
            }
          "
          style="
            padding: 4px;
            font-size: 12px;
            border: 1px solid #ccc;
            margin-left: 10px;
          "
        >
          <option value="5">5</option>
          <option value="10">10</option>
          <option value="20">20</option>
          <option value="50">50</option>
          <option value="100">100</option>
          <option value="500" disabled>500</option>
          <option value="1000" disabled>1000</option>
        </select>
      </template>
    </div>
  </div>
</template>

<script>
import Tree from "../components/Tree";
import treeBtn from "../components/treeBtn";
import axios from "axios";
import VPagination from "@hennge/vue3-pagination";
import "@hennge/vue3-pagination/dist/vue3-pagination.css";
export default {
  name: "QueryGrid",
  components: {
    VPagination,
    Tree,
    treeBtn,
  },
  props: {
    config: Object,
  },
  watch: {
    config() {
      this.filter_values = this.$parent.$route.query.qg_opt
        ? JSON.parse(this.$parent.$route.query.qg_opt)
        : {}; // wipe search when config changes
      this.records = [];
      this.total = 0;
      this.strFullName = "";
    },
  },
  data: function () {
    return {
      isMounted: false,
      filter_values: {},
      firstlists: [],
      sublists: [],
      subclasslists: [],
      substudentlists: [],
      records: [],
      strName: "ALL",
      strFullName: "ALL",
      total: 0,
      offset: 0,
      sint: 0,
      order_reverse: false,
      order_by: "",
      subselected: "",
      cate_filter_class: "",
      cate_filter_student: "",
      limit: 20,
      searchType: "Count",
      page: 1,
    };
  },
  mounted() {
    //datetime format "YYYY-MM-DD HH:mm:ss"
    var timezoneOffset = new Date().getTimezoneOffset() * 60 * 1000;
    var now = new Date(Date.now() - timezoneOffset); // 현재 날짜 및 시간
    var st_date = now.toISOString().substr(0, 10).replace("T", " ");
    var oneMonthAgo = new Date(now.setMonth(now.getMonth() - 1))
      .toISOString()
      .substr(0, 10)
      .replace("T", " "); // 한달 전
    var sixMonthAgo = new Date(now.setMonth(now.getMonth() - 5))
      .toISOString()
      .substr(0, 10)
      .replace("T", " "); // 여섯달 전
    //console.log(oneMonthAgo)

    document.getElementById("search_start").setAttribute("min", sixMonthAgo);
    document.getElementById("search_end").setAttribute("min", sixMonthAgo);

    document.getElementById("search_start").setAttribute("max", st_date);
    document.getElementById("search_end").setAttribute("max", st_date);

    this.search_start = oneMonthAgo;
    this.search_end = st_date;

    if (this.$root.guiPerm == "ROOT") {
      axios.get("/admin/sub_categories").then((response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "데이터를 조회할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          this.firstlists = response.data.result;
          //console.log(this.firstlists);
        }
      });
    } else if (this.$root.guiPerm == "LOCAL") {
      axios
        .get("/admin/sub_categories/" + this.$root.guiPerm)
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            this.sublists = response.data.result;
            //console.log(this.firstlists);
          }
        });
    } else if (
      this.$root.guiPerm == "ENTERPRISE" ||
      this.$root.guiPerm == "CLASS"
    ) {
      axios
        .get("/admin/class_categories/" + this.$root.guiPerm)
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            this.subclasslists = response.data.result;
            this.search(true, "ALL");
            //console.log(this.firstlists);
          }
        });
    }

    this.limit = this.config.default_limit ? this.config.default_limit : 20;
    this.isMounted = true;
    this.filter_values = this.$parent.$route.query.qg_opt
      ? JSON.parse(this.$parent.$route.query.qg_opt)
      : {}; // wipe search when config changes
  },
  methods: {
    clear_var(filter_id) {
      Object.keys(this.filter_values).forEach((k) => {
        if (k.startsWith(filter_id)) {
          delete this.filter_values[k];
        }
      });
      if (this.$refs["search" + filter_id].length) {
        this.$refs["search" + filter_id][0].reset([]);
      }
    },
    toggleAllChecks() {
      var to = null;
      var status = this.getAllCheckStatus();
      if (status <= 0) {
        to = true;
      } else {
        to = false;
      }
      this.updateAllChecks(to);
    },
    updateAllChecks(status) {
      this.records.forEach((v) => {
        v.checked = !!status;
      });
    },
    getAllCheckStatus() {
      var checks = this.records.map((x) => x.checked || false);
      console.log(checks);
      if (!checks.includes(true)) {
        console.log(-1);
        return -1;
      } else if (!checks.includes(false)) {
        console.log(1);
        return 1;
      } else {
        console.log(0);
        return 0;
      }
    },
    sortAction(item_name) {
      if (this.order_by == item_name) {
        if (this.order_reverse) {
          this.order_by = "";
          this.order_reverse = false;
        } else {
          this.order_reverse = true;
        }
      } else {
        this.order_by = item_name;
        this.order_reverse = false;
      }
      this.search();
    },
    selectedSearchBiz(filter_id, biz) {
      console.log(biz);
      this.filter_values[filter_id] = biz;
      this.search(true, "ALL");
    },
    selectedSearchClass(biz) {
      this.filter_values[this.cate_filter_class] = biz;
      this.search(true, "ALL");
    },
    selectedSearchstudent(biz) {
      this.filter_values[this.cate_filter_student] = biz;
      this.search(true, "ALL");
    },
    async getExtras(include_paging) {
      var extras = include_paging
        ? "?limit=" + this.limit + "&offset=" + this.offset
        : "?";
      if (this.cate_filter_class) {
        extras += "&cate_filter_class=" + this.cate_filter_class;
      }
      if (this.cate_filter_student) {
        extras += "&cate_filter_student=" + this.cate_filter_student;
      }
      if (this.subselected) {
        extras += "&subselected=" + this.subselected;
      }
      if (this.search_start) {
        extras += "&" + "search_start=" + this.search_start;
      }
      if (this.search_end) {
        extras += "&" + "search_end=" + this.search_end;
      }
      if (this.searchType) {
        extras += "&" + "searchType=" + this.searchType;
      }

      if (this.order_by) {
        extras += "&order_by=" + this.order_by;
        if (this.order_reverse) {
          extras += "&order_reverse=y";
        }
      }

      if (this.config.extras_addon)
        extras += await this.config.extras_addon(
          this.filter_values,
          this.limit,
          this.offset
        );

      return extras;
    },
    async search(reset, strname) {
      if (reset) {
        this.offset = 0;
        this.page = 1;
      }

      this.strName = strname;
      this.strFullName = strname;

      var extras = await this.getExtras(true);
      axios.get(this.config.req_endpoint + extras).then(async (response) => {
        if (response.data.error) {
          $.notify(
            {
              // options
              message: "데이터를 조회할 수 없습니다. " + response.data.error,
            },
            {
              // settings
              type: "danger",
              z_index: 9999,
            }
          );
        } else {
          if (this.config.grid_parser) {
            var parse_result = await this.config.grid_parser(response.data);
            this.records = parse_result.records;
            this.total = parse_result.total;
          } else {
            this.records = response.data.result;
            this.total = response.data.total;
          }
        }
      });
    },
    async searchLA(reset, strname, sint) {
      if (reset) {
        this.offset = 0;
        this.page = 1;
      }

      this.strName = strname;
      this.strFullName = strname;
      this.sint = sint;

      var extras = (await this.getExtras(true)) + "&type=" + sint;
      axios
        .get("/studies/progress_report_LA" + extras)
        .then(async (response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            if (this.config.grid_parser) {
              var parse_result = await this.config.grid_parser(response.data);
              this.records = parse_result.records;
              this.total = parse_result.total;
            } else {
              this.records = response.data.result;
              this.total = response.data.total;
            }
          }
        });
    },
    async searchAme(reset, strname) {
      /*
        if(!this.cate_filter_class){
          $.notify({
            // options
            message: '클래스를 선택하셔야 합니다. '
          }, {
            // settings
            type: 'danger',
            z_index: 9999
          });
          return;
        }
*/
      if (reset) {
        this.offset = 0;
        this.page = 1;
      }

      this.strName = strname;
      this.strFullName = strname;

      var extras = await this.getExtras(true);
      axios
        .get("/studies/progress_report_Ame" + extras)
        .then(async (response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            if (this.config.grid_parser) {
              var parse_result = await this.config.grid_parser(response.data);
              this.records = parse_result.records;
              this.total = parse_result.total;
            } else {
              this.records = response.data.result;
              this.total = response.data.total;
            }
          }
        });
    },
    async getExcel() {
      var extras = await this.getExtras(false);
      axios
        .get(this.config.req_endpoint + extras + "&limit=2147483647&offset=0")
        .then(async (response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            var csv =
              '<meta http-equiv="Content-Type" content="application/vnd.ms-excel; charset=UTF-8" /><head><style>td{mso-number-format: "@";}</style><body><table><tr>';

            csv += '<th rowspan="2">Class</th>';
            csv += '<th rowspan="2">Id</th>';
            csv += '<th rowspan="2">Name</th>';
            csv +=
              '<th colspan="4" style="background:#f0f0f0!important;">Word Speaking</th>';
            csv += '<th colspan="4">Word Writing</th>';
            csv +=
              '<th colspan="4" style="background:#f0f0f0!important;">Sentence Speaking</th>';
            csv += '<th colspan="3">Sentence Writing</th>';
            csv +=
              '<th colspan="2" style="background:#f0f0f0!important;">Dubbing</th>';
            csv += '<th rowspan="2">Total</th>';
            csv += "</tr>";
            csv += "<tr>";
            csv += '<td style="background:#f0f0f0!important;">Listen</td>';
            csv += '<td style="background:#f8f8f8!important;">Shadowing</td>';
            csv += '<td style="background:#f0f0f0!important;">Pretest</td>';
            csv += '<td style="background:#f8f8f8!important;">Test</td>';
            csv += '<td style="background:#f0f0f0!important;">Practice</td>';
            csv += '<td style="background:#f8f8f8!important;">Quiz</td>';
            csv += '<td style="background:#f0f0f0!important;">Pretest</td>';
            csv += '<td style="background:#f8f8f8!important;" >Test</td>';
            csv += '<td style="background:#f0f0f0!important;">Shadowing</td>';
            csv += '<td style="background:#f8f8f8!important;">Practice</td>';
            csv += '<td style="background:#f0f0f0!important;">Pretest</td>';
            csv += '<td style="background:#f8f8f8!important;">Test</td>';
            csv += '<td style="background:#f8f8f8!important;">Practice</td>';
            csv += '<td style="background:#f0f0f0!important;">Pretest</td>';
            csv += '<td style="background:#f8f8f8!important;">Test</td>';
            csv += '<td style="background:#f0f0f0!important;">Practice</td>';
            csv += '<td style="background:#f8f8f8!important;">Live</td>';

            csv += "</tr>";

            var records = [];
            if (this.config.grid_parser) {
              var parse_result = await this.config.grid_parser(response.data);
              records = parse_result.records;
            } else {
              records = response.data.result;
            }

            records.forEach((data) => {
              csv += "<tr>";
              csv +=
                '<td style="text-align:center;">' +
                (data.t1.name || "").toString().replaceAll("\n", "<br>") +
                "</td>";
              csv +=
                '<td style="text-align:center;">' +
                (data.username || "").toString().replaceAll("\n", "<br>") +
                "</td>";
              csv +=
                '<td style="text-align:center;">' +
                (data.name || "").toString().replaceAll("\n", "<br>") +
                "</td>";
              csv +=
                '<td style="text-align:center;">' +
                (data.cWS_LIS || "").toString().replaceAll("\n", "<br>") +
                "</td>";
              csv +=
                '<td style="text-align:center;">' +
                (data.cWS_PRE || "").toString().replaceAll("\n", "<br>") +
                "</td>";
              csv +=
                '<td style="text-align:center;">' +
                (data.cWS_TEST || "").toString().replaceAll("\n", "<br>") +
                "</td>";
              csv +=
                '<td style="text-align:center;">' +
                (data.cWS_SHA || "").toString().replaceAll("\n", "<br>") +
                "</td>";
              csv +=
                '<td style="text-align:center;">' +
                (data.cWW_PRA || "").toString().replaceAll("\n", "<br>") +
                "</td>";
              csv +=
                '<td style="text-align:center;">' +
                (data.cWW_QUIZ || "").toString().replaceAll("\n", "<br>") +
                "</td>";
              csv +=
                '<td style="text-align:center;">' +
                (data.cWW_PRE || "").toString().replaceAll("\n", "<br>") +
                "</td>";
              csv +=
                '<td style="text-align:center;">' +
                (data.cWW_TEST || "").toString().replaceAll("\n", "<br>") +
                "</td>";
              csv +=
                '<td style="text-align:center;">' +
                (data.cSS_PRA || "").toString().replaceAll("\n", "<br>") +
                "</td>";
              csv +=
                '<td style="text-align:center;">' +
                (data.cSS_SHA || "").toString().replaceAll("\n", "<br>") +
                "</td>";
              csv +=
                '<td style="text-align:center;">' +
                (data.cSS_PRT || "").toString().replaceAll("\n", "<br>") +
                "</td>";
              csv +=
                '<td style="text-align:center;">' +
                (data.cSS_TEST || "").toString().replaceAll("\n", "<br>") +
                "</td>";
              csv +=
                '<td style="text-align:center;">' +
                (data.cSW_PRA || "").toString().replaceAll("\n", "<br>") +
                "</td>";
              csv +=
                '<td style="text-align:center;">' +
                (data.cSW_QUIZ || "").toString().replaceAll("\n", "<br>") +
                "</td>";
              csv +=
                '<td style="text-align:center;">' +
                (data.cSW_TEST || "").toString().replaceAll("\n", "<br>") +
                "</td>";
              csv +=
                '<td style="text-align:center;">' +
                (data.cDU_PRA || "").toString().replaceAll("\n", "<br>") +
                "</td>";
              csv +=
                '<td style="text-align:center;">' +
                (data.cDU_LIVE || "").toString().replaceAll("\n", "<br>") +
                "</td>";
              csv +=
                '<td style="text-align:center;">' +
                (data.tt || "").toString().replaceAll("\n", "<br>") +
                "</td>";

              csv += "</tr>";
            });
            csv += "</table></body>";
            var filename = "progress_report (" + new Date() + ") " + ".xls";
            const blob = new Blob([csv], { type: "text/xls" });
            const elem = window.document.createElement("a");
            elem.href = window.URL.createObjectURL(blob);
            elem.download = filename;
            document.body.appendChild(elem);
            elem.click();
            document.body.removeChild(elem);
          }
        });
    },
    pushSetting(config_name, value) {
      this.filter_values[config_name] = value;
    },
    viewSecond() {
      this.subselected = "";
      this.cate_filter_class = "";
      this.cate_filter_student = "";
      this.sublists = "";
      this.subclasslists = "";
      this.substudentlists = "";
      axios
        .get("/admin/sub_categories/" + this.firstselected)
        .then((response) => {
          if (response.data.error) {
            $.notify(
              {
                // options
                message: "데이터를 조회할 수 없습니다. " + response.data.error,
              },
              {
                // settings
                type: "danger",
                z_index: 9999,
              }
            );
          } else {
            this.sublists = response.data.result;
          }
        });
    },
    viewclass() {
      this.cate_filter_class = "";
      this.cate_filter_student = "";
      this.subclasslists = "";
      this.substudentlists = "";
      if (this.subselected) {
        axios
          .get("/admin/class_categories/" + this.subselected)
          .then((response) => {
            if (response.data.error) {
              $.notify(
                {
                  // options
                  message:
                    "데이터를 조회할 수 없습니다. " + response.data.error,
                },
                {
                  // settings
                  type: "danger",
                  z_index: 9999,
                }
              );
            } else {
              this.subclasslists = response.data.result;
            }
          });
      }
    },
    viewClassStudent() {
      this.cate_filter_student = "";
      this.substudentlists = "";
      if (this.cate_filter_class) {
        axios
          .get("/admin/class_students/" + this.cate_filter_class)
          .then((response) => {
            if (response.data.error) {
              $.notify(
                {
                  // options
                  message:
                    "데이터를 조회할 수 없습니다. " + response.data.error,
                },
                {
                  // settings
                  type: "danger",
                  z_index: 9999,
                }
              );
            } else {
              this.substudentlists = response.data.result;
              this.cate_filter_student = "";
            }
          });
      }
    },
  },
  computed: {
    checked: function () {
      return this.records.filter((record) => record.checked);
    },
  },
};
</script>

<style></style>
